/**
 * main.tsx — application entry point.
 *
 * Intentionally kept as a pure entry point (createRoot + render only) so the
 * react-refresh/only-export-components rule is not tripped. Provider wiring
 * lives in Root.tsx; i18n initialisation is a side-effect import below.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './core/i18n'; // side-effect: initialises i18next before first render
import './core/pwa/registerServiceWorker'; // side-effect: registers the Workbox service worker
import './print.css'; // side-effect: global @media print overrides (slice 441)
import Root from './Root';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
